import { render, staticRenderFns } from "./CustomerLookupControl.vue?vue&type=template&id=4965e4d8&scoped=true&"
import script from "./CustomerLookupControl.vue?vue&type=script&lang=js&"
export * from "./CustomerLookupControl.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLookupControl.vue?vue&type=style&index=0&id=4965e4d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4965e4d8",
  null
  
)

export default component.exports